// extracted by mini-css-extract-plugin
export default {"mobileStore":"Store_mobileStore__nbHKo"};